import React, { useState } from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
  Paper,
  Link,
  IconButton,
  Tooltip,
  Backdrop
} from "@mui/material";
import {
  makeStyles,
  CircularProgress
} from "@material-ui/core";

import { API } from "aws-amplify";

import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import MiniAssignPopUp from "../MiniAssignPopUp";
import config from "../../../../config/aws-exports";
import { useSelector, useDispatch } from "react-redux";
import { authData } from "../../../../redux/auth/authSlice";
import UserProgressPopUp from "../UserProgress";
import AssignAndAssessPopUp from "../AssignAndAssesScore";
import "../BatchAnalytics.scss"
import { Button } from "semantic-ui-react";
import Downloadcsv from "../Downloadcsv";


const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Dessert (100g serving)",
    headerClassName: 'super-app-theme--header'
  },
  {
    id: "calories",
    numeric: true,
    disablePadding: false,
    label: "Calories",
    headerClassName: 'super-app-theme--header'
  },
  {
    id: "fat",
    numeric: true,
    disablePadding: false,
    label: "Fat (g)",
    headerClassName: 'super-app-theme--header'
  },
  {
    id: "carbs",
    numeric: true,
    disablePadding: false,
    label: "Carbs (g)",
    headerClassName: 'super-app-theme--header'
  },
  {
    id: "protein",
    numeric: true,
    disablePadding: false,
    label: "Protein (g)",
    headerClassName: 'super-app-theme--header'
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead th>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: "1 1 100%" }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Users
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
const useStyles = makeStyles({
  root: {
    display: "inline-block",
    width: "100%",
    paddingTop: "20px",
    '& .super-app-theme--header': {
      backgroundColor: config.main_color_1,
      fontSize: "16px",
      color: 'rgb(255,255,255)',
      fontFamily: "nunito"
    },
  },
  root1: {
    width: "100%",
  },
  programtitle: {
    fontSize: "18px",
    color: config.main_color_1,
  },
  heading: {
    fontSize: "18px",
    fontWeight: 400,
    color: config.main_color_1,
  },
  coursetitle: {
    fontSize: "16px",
    fontWeight: 400,
    color: config.main_color_2,
  },
  modulename: {
    fontSize: "14px",
    fontWeight: 400,
    color: "black",
    width: "60%",
  },
  subheading: {
    color: "black",
    fontFamily: "nunito",
    fontSize: "14px",
    fontWeight: "600px",
  },
  "MuiAccordionDetails-root": {
    display: "inline-block",
    width: "100%",
    padding: "10px 20px",
  },
});


export default function EnhancedTable(batchAnalytics, courseId) {
  const [uname, setUname] = useState("");
  const [minOpen, setMinOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState({ open: false });
  const [assignOpen, setAssignOpen] = useState(false)
  const [userPopOpen, setUserPopOpen] = useState(false);
  const [courseData, setCourseData] = useState(null);
  const [minAssignData, setMinAssignData] = useState(null);
    const [assignAndAssessData, setAssignAndAssessData] = useState(null);
    let arrHeader = ["UNAME", "EMAILID","MINIAVG","ASSIGNAVG","ASSESSAVG"];
    let newHeaders = ["Name", "EmailID","Mini assignment","Assignments","Assessment"];
  const classes = useStyles();
  const dispatch = useDispatch();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  let userDetails = useSelector(authData);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  console.log("insidetable", batchAnalytics);
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  // This method is created for cross-browser compatibility, if you don't
  // need to support IE11, you can use Array.prototype.sort() directly
  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleClick = (indx, id) => {
    console.log(indx, id);
    console.log(batchAnalytics.batchAnalytics[indx]);
    setLoading(true);
    setUname(batchAnalytics.batchAnalytics[indx].UNAME);
    if (id === "MINIAVG") {
      getMiniAssign(batchAnalytics.batchAnalytics[indx].EID);
      //setLoading(false);
    } else if (id === "ASSIGNAVG") {
      getAssignAndAssess(batchAnalytics.batchAnalytics[indx].EID,'assign');
    } else if (id === "ASSESSAVG") {
      getAssignAndAssess(batchAnalytics.batchAnalytics[indx].EID,'assess');
    } else {
      getCourse(batchAnalytics.batchAnalytics[indx].EID);
      // let sdata = { ...userDetails };
      // sdata.ueid = batchAnalytics.batchAnalytics[indx].EID;
      // dispatch(awsSignIn(sdata));
    }
  };
  async function getCourse(eid) {
    //setIsLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        eid: eid,
        pid: userDetails.curprgcou.pid,
        bpid: userDetails.curprgcou.bpid,
        courseid: userDetails.cid,
        bcourseid: userDetails.bcid,
        //ptitle: ptitle,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log(bodyParam.body);
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getCourse",
        bodyParam
      );
      console.log(response);
      if (
        response === undefined ||
        response === null ||
        Object.keys(response).length === 0
      ) {
        setCourseData(null);
      } else {
        setCourseData(response);
        setUserPopOpen(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }
  async function getMiniAssign(eid) {
    //setIsLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        eid: eid,
        pid: userDetails.curprgcou.pid,
        bpid: userDetails.curprgcou.bpid,
        cid: userDetails.cid,
        bcid: userDetails.bcid,
        //ptitle: ptitle,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log("getUserCourseminiAssign==", bodyParam.body);
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getUserCourseminiAssign",
        bodyParam
      );
      console.log(response);
      if (response === undefined || response === null) {
        setMinAssignData(null);
      } else {
      
        setMinAssignData(response);
        setMinOpen(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }
  async function getAssignAndAssess(eid,type) {
    //setIsLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        eid: eid,
        pid: userDetails.curprgcou.pid,
        bpid: userDetails.curprgcou.bpid,
        cid: userDetails.cid,
        bcid: userDetails.bcid,
        quiztype: type,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      console.log("getUserAssignAndAsses==",bodyParam.body);
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getUserAssignAndAsses",
        bodyParam
      );
      console.log(response);
      if (
        response === undefined ||
        response === null 
      ) {
        setAssignAndAssessData(null);
      } else {
       
        setAssignAndAssessData(response);
        modalOpen.open = true;
        modalOpen.type = type;
        setModalOpen(modalOpen)
        setAssignOpen(true);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  }
  // Avoid a layout jump when reaching the last page with empty rows.
  const columns = [
    { id: "UNAME", label: "Name", minWidth: 170 , headerClassName: 'super-app-theme--header'},
    { id: "EMAILID", label: "Email", minWidth: 100, headerClassName: 'super-app-theme--header' },
    {
      id: "MINIAVG",
      label: "Mini assignments avg score",
      minWidth: 170,
      align: "center",
      headerClassName: 'super-app-theme--header'
    },
    {
      id: "ASSIGNAVG",
      label: "Assignments avg score",
      minWidth: 170,
      align: "center",
      headerClassName: 'super-app-theme--header'
    },
    {
      id: "ASSESSAVG",
      label: "Assessments avg score",
      minWidth: 170,
      align: "center",
      headerClassName: 'super-app-theme--header'
    },
  ];
  const createSortHandler = (property) => (event) => {
   // onRequestSort(event, property);
  };
  function EnhancedTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
      props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead>
        <TableRow >
       
          {columns.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{background: config.main_color_1, color: "white", fontSize: "14px", fontWeight: "400px"}}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  return (
    <>
    {loading && (
       <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
       open={true}
     >

      <CircularProgress className="spinnerStyle"/>
     </Backdrop>
         
              )}


  {assignOpen && (
        <AssignAndAssessPopUp
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        assignAndAssessData={assignAndAssessData}
        setAssignOpen={setAssignOpen}
        assignOpen={assignOpen}
        uname = {uname}
       
        />
      )}
            {minOpen && (
        <MiniAssignPopUp
          minOpen={minOpen}
          setMinOpen={setMinOpen}
          minAssignData={minAssignData}
          uname = {uname}
         
        />
      )}
      {userPopOpen && (
        <UserProgressPopUp
          userPopOpen={userPopOpen}
          setUserPopOpen={setUserPopOpen}
          courseData={courseData}
          uname = {uname}
         
        />
      )}
      {batchAnalytics.batchAnalytics !== undefined && 
      batchAnalytics.batchAnalytics.length !== 0 &&(
        <Box sx={{ width: "100%" }}>
          <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "15px"}}>
            <h3 style={{fontSize: "18px"}}>Users</h3>
            <Downloadcsv maindata={batchAnalytics.batchAnalytics} arrHeader={arrHeader} 
            newHeaders={newHeaders} filename={"Batch"} />  
          </div>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 440 }}>
              <Table stickyHeader aria-label="sticky table">
              <EnhancedTableHead
              order={order}
              orderBy={orderBy}
           
              onRequestSort={handleRequestSort}
              rowCount={columns.length}
            />
                <TableBody>
                  { stableSort(batchAnalytics.batchAnalytics, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.code}
                        >
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ fontSize: "13.5px" }}
                                
                              > 
                             
                              {column.id === "EMAILID" ? (
                                  value
                                ) : (
                                  <Link
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      if(value !== 0){
                                         handleClick(idx, column.id);
                                       }
                                    }}
                                  >
                                    {value}
                                  </Link>
                                )}
                             
                                
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={batchAnalytics.batchAnalytics.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Box>
      )}
      {(batchAnalytics.batchAnalytics === undefined || 
      batchAnalytics.batchAnalytics.length === 0) && (
        <>
        No Rows
        </>
      )}
    </>
  );
}
